import { render } from "./admin-view-log-department.vue?vue&type=template&id=fab0dbee"
import script from "./admin-view-log-department.vue?vue&type=script&lang=js"
export * from "./admin-view-log-department.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/admin/admin-view-log-department.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fab0dbee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fab0dbee', __exports__)) {
    api.reload('fab0dbee', __exports__)
  }
  
  module.hot.accept("./admin-view-log-department.vue?vue&type=template&id=fab0dbee", () => {
    api.rerender('fab0dbee', render)
  })

}


export default __exports__